import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { VonRestInterceptorService } from '@von-development-studio/angular-rest-service';
import { screenActions } from 'src/app/store/screen/screen-store.action';
import { environment } from 'src/environments/environment';

@Injectable()
export class RestInterceptorService extends VonRestInterceptorService {
  override consoleDebug = environment.consoleDebug;
  override errorResponseUnknown =
    'No se pudo completar la acción. Comunícate con el administrador del sistema.';
  override errorResponseForbidden = 'No se pudo completar la acción.';
  override urlWhoAmI = 'api/who-am-i';

  constructor(override router: Router, protected store: Store<any>) {
    super(router);
  }

  override postHttpRequest = () => {
    this.store.dispatch(
      screenActions.setScreenLoadingAction({ loading: false })
    );
  };
}
